






































import { Company } from '@/models';

import config from "../../../../config";

declare var Stripe: any;
import Vue from 'vue';

export default Vue.extend({
    props: ['showHeading','showCancel', 'showScaWarning', 'saveButtonText'],
    data() {
		return {
			company: Company,
			stripe: undefined as any,
			loading: false,
      card: undefined as any,
      verificatonError: '',
      cardAdded: false,
		}
	},
    created() {
        this.fetchCompanyDetails();
    },
    mounted(){
        this.initStripeBar();
    },
    methods:{
        async fetchCompanyDetails(){
          let company = await this.$store.dispatch('company/get');
          this.company = company.data;
        },
        async initStripeBar(){
            var _self = this;

            let recaptchaScript = document.createElement('script')
            recaptchaScript.onload = () => {
                _self.stripe = Stripe(config.stripeKey);
                // Create an instance of Elements.
                var elements = _self.stripe.elements();

                // Custom styling can be passed to options when creating an Element.
                // (Note that this demo uses a wider set of styles than the guide below.)
                var style = {
                    base: {
                        color: '#2a3135',
                        lineHeight: '21px',
                        fontFamily: 'Roboto,system,-apple-system,BlinkMacSystemFont,".SFNSDisplay-Regular","Helvetica Neue",Helvetica,Arial,sans-serif',
                        fontSmoothing: 'antialiased',
                        fontSize: '14px',
                        '::placeholder': {
                            color: '#aab7c4'
                        }
                    },
                    invalid: {
                        color: '#fa755a',
                        iconColor: '#fa755a'
                    }
                };

                // Create an instance of the card Element.
                this.card = elements.create('card', { style: style });

                // Add an instance of the card Element into the `card-element` <div>.
                this.card.mount('#card-element');

                this.card.addEventListener('change', function (event: any) {
                    var displayError = document.getElementById('card-errors') || document.createElement('div');
                    if (event.error) {
                        displayError.textContent = event.error.message;
                    } else {
                        displayError.textContent = '';
                    }
                });
            }

            recaptchaScript.setAttribute('src', 'https://js.stripe.com/v3/')
            document.head.appendChild(recaptchaScript)
        },

    cancel() {
      this.card.clear();
      this.$emit('cancel');
		},
		async tokenize() {
      this.loading = true;
      this.verificatonError = '';
      this.cardAdded = false;
      const _self = this;

      try{
        const intent = await this.$http.post('/api/stripe/setup_intent',{});
        await this.stripe
          .confirmCardSetup(intent.data.client_secret, {
              payment_method: {
                  card: this.card,
                  // billing_details: {
                  //     name: this.fullName
                  // }
              }
          })
          .then( (result: any) => {
              if (result.error) {
                  // _self.paymentError = result.error.message
                  this.verificatonError = result.error.message
                  this.loading = false
              } else {
                  // Send the token to your server.
                  let paymentMethodId = result.setupIntent.payment_method
                  this.updateCard(paymentMethodId);
              }
          })
        } catch (err) {
          this.loading = false;
          //
        }
      },
      async updateCard(paymentMethodId:string) {
        try {
          let resp = await this.$http.post('/api/stripe/add_card', {
          payment_method_id: paymentMethodId,
          stripe_id: this.company.stripe_id,
          company_id: this.company.id
        })
          this.card.clear()
          this.loading = false
          this.cardAdded = true;
          this.$emit('cardChanged');
          setTimeout(() => {
            this.fetchCompanyDetails()
          }, 500)
          setTimeout(() => {
            this.fetchCompanyDetails()
            this.$emit('cardChangedTimeout');
          }, 2000)
        } catch (err) {
          this.verificatonError = err?.response?.data?.msg || 'Adding new payment method failed';
          this.loading = false
        }
        this.card.clear();
      }
  }
})
